<template>
  <div>
    <!-- Header -->
    <Header
        headerTitle="获取离场凭证"
        :hasBackBtn="true"
        :rightIconSrc="require('../assets/img/dianhua.png')"
        :iconShow="true"
    ></Header>

    <div class="main-container" style="padding-top:5px">
      <div class="cardId">
        <div>
          <span>{{result.licenseplate}}</span>
        </div>
      </div>
      <div>
        <p>停放车位: {{result.parkingId}}</p>
      </div>
      <div>
        <p>开始时间: {{result.actualInTime}}</p>
      </div>
      <div>
        <p>结束时间: {{result.actualOutTime}}</p>
      </div>
      <div>
        <p>停车时长: {{result.actualTime/60}}</p>
      </div>
      <div><p>温馨提示: 获取凭证后请在15分钟内驶离停车场</p></div>
    </div>
  </div>
</template>
<script>
  import {orderListByDetails} from "../api/order.js"

  export default {
    name: "LeaveVoucher",
    data() {
      return {
        result: [], //数据
        orderId: "", //订单Id
        phone: "400-115-0606", //电话
      };
    },
    methods: {
      getOrderDetail() {
        //数据方法
        orderListByDetails({orderId: this.orderId}).then(response => {
          if (response.data.status == 200) {
            this.result = response.data.result;
          }
        });
      }

    },
    //加载事件
    created() {
      this.orderId = this.$route.params.orderId; //订单Id
      this.getOrderDetail();
    }
  };
</script>

<style>
  header,
  section p {
    margin: 0 auto;
    padding: 0;
  }

  header {
    text-align: center;
    font-size: 19px;
    color: black;
    padding: 10px;
    padding-bottom: 5px;
  }

  header .return {
    display: inline-block;
    float: left;
    vertical-align: middle;
    font-size: 14px;
  }

  header .title {
    text-align: center;
  }

  header .imgIco {
    display: inline-block;
    float: right;
  }


</style>


